import getDiagnosticData from './diagnostics';
import getRegistrationData from './registration';
import getSaleData from './sale';
import getSupportData from './support';
import getDefaultData from './default';

const PROCESS_TYPES = {
    Diagnostic: (args) => getDiagnosticData(args),
    Registration: (args) => getRegistrationData(args),
    Sale: (args) => getSaleData(args),
    Support: (args) => getSupportData(args),
    None: (args) => getDefaultData(args)
};

export default PROCESS_TYPES;
